import styled from "styled-components";
import { Modal as Base } from "@sablier/v2-components/organisms";
import { useT } from "@sablier/v2-locales";
import { _ } from "@sablier/v2-mixins";
import { useModalMomentPicker } from "~/client/hooks";
import Body from "./Body";

const Modal = styled(Base.Card)`
  div[data-component="modal-card"] {
    --background-modal: ${(props) => props.theme.colors.dark200};
    max-width: 800px;
  }
`;

function MomentPicker() {
  const { t } = useT();
  const { data, id: modalId } = useModalMomentPicker();

  return (
    <Modal
      id={modalId}
      isBackdropDisabled
      isCloseDisabled
      elevation={200}
      title={t("modalCards.moment.title", {
        purpose: data.purpose || t("structs.dateAndTime"),
      })}
    >
      <Body />
    </Modal>
  );
}

export default MomentPicker;
